import LightningMap from "../../../../src/components/research/map/LightningMap";
import LightningImage from "../../../../src/components/research/lightningImage";
import * as React from 'react';
export default {
  LightningMap,
  LightningImage,
  React
};